export default __webpack_public_path__ + "static/media/bg-secundario-2.fe39194d.gif";